module.exports = __webpack_public_path__ + "img/14.ee792a96.jpg";